// extracted by mini-css-extract-plugin
module.exports = {"finance_micro__div":"finance_micro__div--FIx+o","footerBox":"footerBox--juf6K","btns":"btns--pKSm3"};